module.exports = __webpack_public_path__ + "img/white_paper23.87633c66.png";